/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import useForm from "../../hooks/useForm";
import Button from "../Button";
import SunEditor from "../SunEditor";
import Form from "../Form";
import Modal from "../Modal";
import { addEditorTemplate, editEditorTemplate } from "../../apis/editorTemplate";
import { isEmpty } from "lodash";
import { toast } from "../../utils/toast";
import ToolTip from "../ToolTip/ToolTip";

const AddContract = (props) => {
  const { user } = useSelector((store) => ({
    user: store.Profile.user,
  }));
  const {
    isOpen,
    setIsOpen,
    mode,
    submit: _submit,
    selected,
    setMode,
  } = props;



  const [html, setHtml] = useState(null);
  const [fields] = useState([
    {
      title: "계약서 이름",
      key: "title",
      type: "input",
      required: true,
    },
    {
      title: "설명",
      key: "description",
      type: "input",
      required: true,
    },
  ]);


  const handleOnChangeSunEditor = (content) => {
    setHtml(content.target.value);
  };

  const submit = () => {
    const body = {
      ...form,
      content: html,
      companyIdx: user.companyIdx,
      type: "contract"
    };
    if (mode === "create") {
      addEditorTemplate(body)
        .then(res => {
          toast.success('등록되었습니다.');
          _submit && _submit();
          close();
        }).catch(err => { });
    } else if (mode === "modify") {
      editEditorTemplate(selected.idx, body).then(res => {
        toast.success('수정되었습니다.');
        _submit && _submit();
        close();
      });
    }
  };

  const { form, setForm, errors, handleOnChange, handleSubmit } = useForm(
    {
      title: "",
      description: "",
    },
    submit
  );

  const close = () => {
    setIsOpen(false);
    setMode("create");
  };


  useEffect(() => {
    if (mode === "modify" && !isEmpty(selected)) {
      setHtml(selected.content);
      setForm({
        ...selected
      });
    }
  }, [mode, selected]);

  return (
    <>
      <Modal
        isOpen={isOpen}
        type={"default"}
        close={close}
        className="contract-modal"
      >
        <div className="contract-contents">
          <div className="contract-header-wrap print-out">
            <h2 className="contract-title">
              {mode === "detail" ? (
                <>
                  <h2 className="contract-title">{"사용자 설정 제목"}</h2>
                  <Button
                    label="인쇄"
                    color="gray-line"
                    onClick={() => window.print()}
                    className="print-button"
                  />
                </>
              ) : (
                <>
                  {`계약서 양식 ${mode === "modify" ? "수정" : "등록"}`}
                  <ToolTip
                    className={"title-tooltip"}
                    tooltiptext={'※서명란은 내용에 "(인)" 으로 표기할 수 있습니다.\n첫 번째 (인)은 계약자(회사)의 서명 위치입니다.\n두 번째 (인)은 피계약자(근로자)의 서명 위치입니다.'}
                    position="right"
                  />
                </>
              )}
            </h2>
          </div>
          <div className="contract-form-wrap">
            <Form
              fields={fields}
              form={form}
              onChange={handleOnChange}
              errors={errors}
            />
            <SunEditor
              value={html}
              onChange={handleOnChangeSunEditor}
              readOnly={mode === "detail"}
            />
          </div>
          <div className="print-out">
            <div className="contact-content-button-wrap">
              <Button onClick={close} color={"text"}>
                취소
              </Button>
              <Button onClick={handleSubmit}>{`계약서 양식 ${mode === "create" ? "등록" : "수정"}`}</Button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default AddContract;
